module.exports = __webpack_public_path__ + "static/media/orthotic.09fbaafb.jpg";